import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CANTONES } from "@/constants/cantones";

export const CLIENTE_VACIO = {
  nombre: "", primer_apellido: "", segundo_apellido: "",
  person_id: "", telefono: "", correo: "", tipo: "fisica", ubicacion: "",
};

export const maskTelefono = (v) => {
  const d = v.replace(/\D/g, "").slice(0, 8);
  return d.length > 4 ? `${d.slice(0, 4)}-${d.slice(4)}` : d;
};

export const validarCliente = (v) => {
  const e = {};
  if (!v.nombre.trim()) e.nombre = "Ingrese nombre";
  if (v.tipo === "fisica" && !v.primer_apellido.trim()) e.primer_apellido = "Ingrese primer apellido";
  if (!v.person_id.trim()) e.person_id = "Ingrese número de ID";
  if (!/^\d{4}-\d{4}$/.test(v.telefono)) e.telefono = v.telefono ? "Formato 0000-0000" : "Ingrese teléfono";
  if (v.correo.trim() && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v.correo.trim())) e.correo = "Correo electrónico inválido";
  if (!v.tipo) e.tipo = "Seleccione tipo de persona";
  if (!v.ubicacion) e.ubicacion = "Seleccione ubicación";
  return e;
};

const Campo = ({ label, obligatorio, error, testId, children }) => (
  <div className="space-y-1.5">
    <label className="text-sm font-medium text-slate-700">
      {label} {obligatorio && <span className="text-red-500">*</span>}
    </label>
    {children}
    {error && <p data-testid={`${testId}-error`} className="text-xs text-red-500">{error}</p>}
  </div>
);

export const ClienteForm = ({ valor, onChange, errores = {}, avisoPersonId = null }) => {
  const set = (campo, v) => onChange({ ...valor, [campo]: v });
  const esFisica = valor.tipo === "fisica";
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Campo label="Nombre o Razón Social" obligatorio error={errores.nombre} testId="cliente-nombre">
          <Input data-testid="cliente-nombre-input" value={valor.nombre}
            onChange={(e) => set("nombre", e.target.value)} placeholder="Nombre o Razón Social" />
        </Campo>
        <Campo label="Primer Apellido" obligatorio={esFisica} error={errores.primer_apellido} testId="cliente-primer-apellido">
          <Input data-testid="cliente-primer-apellido-input" value={valor.primer_apellido}
            onChange={(e) => set("primer_apellido", e.target.value)} placeholder="Primer apellido" />
        </Campo>
        <Campo label="Segundo Apellido" error={errores.segundo_apellido} testId="cliente-segundo-apellido">
          <Input data-testid="cliente-segundo-apellido-input" value={valor.segundo_apellido}
            onChange={(e) => set("segundo_apellido", e.target.value)} placeholder="Segundo apellido" />
        </Campo>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Campo label="Número de ID" obligatorio error={errores.person_id} testId="cliente-person-id">
          <Input data-testid="cliente-person-id-input" value={valor.person_id}
            onChange={(e) => set("person_id", e.target.value)} placeholder="Cédula / ID" />
          {avisoPersonId}
        </Campo>
        <Campo label="Teléfono" obligatorio error={errores.telefono} testId="cliente-telefono">
          <Input data-testid="cliente-telefono-input" value={valor.telefono} inputMode="numeric"
            onChange={(e) => set("telefono", maskTelefono(e.target.value))} placeholder="0000-0000" />
        </Campo>
        <Campo label="Correo Electrónico" error={errores.correo} testId="cliente-correo">
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm font-medium">@</span>
            <Input data-testid="cliente-correo-input" value={valor.correo} className="pl-8"
              onChange={(e) => set("correo", e.target.value)} placeholder="correo@ejemplo.com" />
          </div>
        </Campo>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Campo label="Tipo de Persona" obligatorio error={errores.tipo} testId="cliente-tipo">
          <Select value={valor.tipo} onValueChange={(v) => set("tipo", v)}>
            <SelectTrigger data-testid="cliente-tipo-select"><SelectValue placeholder="Seleccione" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="fisica" data-testid="cliente-tipo-fisica">Física</SelectItem>
              <SelectItem value="juridica" data-testid="cliente-tipo-juridica">Jurídica</SelectItem>
            </SelectContent>
          </Select>
        </Campo>
        <Campo label="Ubicación" obligatorio error={errores.ubicacion} testId="cliente-ubicacion">
          <Select value={valor.ubicacion} onValueChange={(v) => set("ubicacion", v)}>
            <SelectTrigger data-testid="cliente-ubicacion-select"><SelectValue placeholder="Seleccione cantón" /></SelectTrigger>
            <SelectContent className="max-h-72">
              {CANTONES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
            </SelectContent>
          </Select>
        </Campo>
      </div>
    </div>
  );
};
